import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Response from '@careers-wales/react-components/dist/components/utilities/Response/Response.js';
import useErrors from '@careers-wales/react-components/dist/hooks/useErrors';
import useLanguageSwitcher from '@careers-wales/react-components/dist/hooks/useLanguageSwitcher';
import DetailView from './DetailView';
import { routeTranslated } from '../../routes';
import useEventsApi from '@careers-wales/react-components/dist/hooks/api/useEventsApi.js';
import { useParams } from 'react-router-dom';
import useAuthentication from '@careers-wales/react-components/dist/hooks/useAuthentication';
import { route } from '../../routes';
import useNavigate from '@careers-wales/react-components/dist/hooks/useNavigate';
import config from '../../config';

function DetailController(props) {
  const { i18n } = useTranslation();
  const { setLanguageSwitcherHref } = useLanguageSwitcher();
  const { errors, setError } = useErrors();
  const [event, setEvent] = useState({});
  const [hasEventLoaded, setHasEventLoaded] = useState(false);
  const { getEvent } = useEventsApi(process.env);
  const { id } = useParams();

  const { hasRole } = useAuthentication();
  const navigate = useNavigate(config);

  useEffect(() => {
    setLanguageSwitcherHref(routeTranslated('detail', { id: event.translatedAlias }));
  }, [event]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getEvent(
      id,
      i18n.language,
      (response) => {
        if (!hasRole('Drupal_Manager') && !response.data.published) {
          // @hack to make navgaite work for now.
          navigate(route('landing'));
        }

        setEvent(response.data);
        setHasEventLoaded(true);
      },
      (error) => {
        setError(error);
      }
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function countSessions(event) {
    let count = 0;
    event.sessions.forEach((location) => {
      location.sessions.forEach((session) => {
        count += 1;
      });
    });

    return count;
  }

  return (
    <Response errors={errors} hasLoaded={hasEventLoaded}>
      <DetailView event={event} countSessions={countSessions} />
    </Response>
  );
}

export default DetailController;
